import React from 'react';

const ScrollNav = ({ scroll, loadListView}) => {
	return (
		<div className='scroll-nav-container'>
		    <p
		      className='button-gray round'
		      onClick={() => scroll('back')}
		    >
		      &#8249;
		    </p>
		    <p
		      className='button-gray'
		      onClick={() => loadListView()}
		    >
		      back
		    </p>
		    <p
		      className='button-gray round'
		      onClick={() => scroll('forward')}
		    >
		      &#8250;
		    </p>
		</div>
	)
}

export default ScrollNav;